// База API + резолв относительных путей.
//
// Capacitor (origin https://localhost) НЕ имеет бэкенда на same-origin — все
// относительные `/api/...` (tRPC, SSE-стримы, PowerSync write/auth) обязаны
// идти на абсолютный VITE_API_URL. На web VITE_API_URL пустой → same-origin
// (Caddy/Vite proxy), поведение не меняется.
//
// Используй apiUrl() для ЛЮБОГО fetch на наш бэкенд, особенно когда путь
// приходит с сервера относительным (например streamUrl из tutor.prepareStream
// = "/api/tutor/stream"). Без префикса SSE-стрим в Capacitor бьёт в localhost
// и висит.

export const API_BASE = (import.meta.env.VITE_API_URL ?? "") as string;

/**
 * Префиксует относительный путь (`/api/...`) абсолютным API_BASE. Уже абсолютные
 * URL (http/https) возвращаются как есть.
 */
export function apiUrl(path: string): string {
	if (/^https?:\/\//i.test(path)) return path;
	return `${API_BASE}${path}`;
}
